/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 17:27:05
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import PageLoading from '@root/components/PageLoading';
import PageLoadError from '@root/components/PageLoadError';
import SafeAreaInset from '@root/components/SafeAreaInset';
import Empty from '@root/components/Empty';
import useBillList from '@root/hooks/bill/useBillList';
import { IOrderBill } from '@root/types/bill';
import { CellCard, CellCommon, CellTitle } from '@root/components/Cell';
import { DATE_TIME_FORMAT } from '@root/constant';
import { Bubbles } from '@root/components/Loading';

const BillList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, loading, isMoreData, onMoreData, getList } = useBillList();

  if (loading < 1 && !list.length) {
    return <PageLoading />;
  }

  if (loading === 2 && !list.length) {
    return <PageLoadError onTryAgain={getList} />;
  }

  return (
    <>
      <CellTitle paddingTop={20}>
        <p className="bill-list-add">
          <Link to="/billAddress">{t('billing_address')}</Link>
        </p>
      </CellTitle>
      {list.length ? (
        <>
          <CellCard marginTop={0}>
            {list.map((item: IOrderBill) => {
              return (
                <CellCommon
                  inner
                  key={item.orderId}
                  title={item.subscribeName}
                  description={
                    item.subscribeDate
                      ? dayjs(item.subscribeDate).format(DATE_TIME_FORMAT)
                      : ''
                  }
                  onClick={() => navigate(`/bills/${item.orderId}`)}
                  arrow
                >
                  ${item.price}
                </CellCommon>
              );
            })}
          </CellCard>
          <div className="list-load-more">
            {loading > 0 && (
              <>
                {isMoreData ? (
                  <p className="more" onClick={onMoreData}>
                    {t('load_more')}
                  </p>
                ) : (
                  <p className="neuter600">{t('no_more')}</p>
                )}
              </>
            )}

            {loading === 0 && list.length > 0 && <Bubbles />}
          </div>
        </>
      ) : (
        <Empty marginBottom={20}>{t('bill_empty')}</Empty>
      )}
      <SafeAreaInset />
    </>
  );
};

export default BillList;
